module.exports = __webpack_public_path__ + "img/127.89e0fd27.png";